import {GoalBannerDefinition} from './goalBanner'

export {GoalBannerDefinition}
